import isBrowser from 'lib/isBrowser';

import { initEnvs } from './initEnvs';

export const replaceQuotes = (value: string | undefined) => value?.replaceAll('\'', '"');

export const getEnvValue = (envName: string) => {
  if (isBrowser() && !(window as any).__envs) {
    initEnvs();
  }

  // eslint-disable-next-line no-restricted-properties
  const envs = (isBrowser() ? ((window as any).__envs || process.env) : process.env) ?? {};

  return replaceQuotes(envs[envName]);
};

export const parseEnvJson = <DataType>(env: string | undefined): DataType | null => {
  try {
    return JSON.parse(env || 'null') as DataType | null;
  } catch (error) {
    return null;
  }
};
